var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "ChangePasswordModal", size: "md" },
      on: { show: _vm.initChangePassword },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between w-100",
                },
                [
                  _c(
                    "h5",
                    { staticClass: "mb-0 font-weight-semibold text-white" },
                    [_vm._v("Change Password")]
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                { staticClass: "w-100 justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "close-btn px-4 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-container",
        { staticClass: "px-2" },
        [
          _c(
            "b-row",
            { staticClass: "pt-1 pb-3 w-100", attrs: { "no-gutters": "" } },
            [
              _c("b-col", { staticClass: "w-75 anchor-left" }, [
                _c("label", { staticClass: "blue-text pl-2" }, [
                  _vm._v("Old Password"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "password-wrapper position-relative w-100" },
                  [
                    _c("b-form-input", {
                      staticClass: "input-field pl-3",
                      class: _vm.missingFields.oldPassword ? "red" : "",
                      attrs: {
                        type: _vm.passwordVisible ? "text" : "password",
                        name: "oldPassword",
                        autocomplete: "off",
                      },
                      on: {
                        focus: function ($event) {
                          _vm.focused.old = true
                          _vm.focused.new = false
                          _vm.focused.confirm = false
                        },
                      },
                      model: {
                        value: _vm.form.oldPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "oldPassword", $$v)
                        },
                        expression: "form.oldPassword",
                      },
                    }),
                    _vm._v(" "),
                    _vm.focused.old
                      ? _c("fa", {
                          staticClass: "password-toggle",
                          attrs: {
                            icon: [
                              "fas",
                              _vm.passwordVisible ? "eye-slash" : "eye",
                            ],
                          },
                          on: {
                            click: function ($event) {
                              _vm.passwordVisible = !_vm.passwordVisible
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "py-3 w-100", attrs: { "no-gutters": "" } },
            [
              _c("b-col", { staticClass: "w-75 anchor-left" }, [
                _c("label", { staticClass: "blue-text pl-2" }, [
                  _vm._v("New Password"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "password-wrapper position-relative w-100" },
                  [
                    _c("b-form-input", {
                      staticClass: "input-field pl-3",
                      class: _vm.missingFields.newPassword ? "red" : "",
                      attrs: {
                        type: _vm.passwordVisible ? "text" : "password",
                        name: "newPassword",
                        autocomplete: "off",
                      },
                      on: {
                        focus: function ($event) {
                          _vm.focused.new = true
                          _vm.focused.old = false
                          _vm.focused.confirm = false
                        },
                      },
                      model: {
                        value: _vm.form.newPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "newPassword", $$v)
                        },
                        expression: "form.newPassword",
                      },
                    }),
                    _vm._v(" "),
                    _vm.focused.new
                      ? _c("fa", {
                          staticClass: "password-toggle",
                          attrs: {
                            icon: [
                              "fas",
                              _vm.passwordVisible ? "eye-slash" : "eye",
                            ],
                          },
                          on: {
                            click: function ($event) {
                              _vm.passwordVisible = !_vm.passwordVisible
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "py-3 w-100", attrs: { "no-gutters": "" } },
            [
              _c("b-col", { staticClass: "w-75 anchor-left" }, [
                _c("label", { staticClass: "blue-text pl-2" }, [
                  _vm._v("Confirm New Password"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "password-wrapper position-relative w-100" },
                  [
                    _c("b-form-input", {
                      staticClass: "input-field pl-3",
                      class: _vm.missingFields.confirmPassword ? "red" : "",
                      attrs: {
                        type: _vm.passwordVisible ? "text" : "password",
                        name: "confirmPassword",
                        autocomplete: "off",
                      },
                      on: {
                        focus: function ($event) {
                          _vm.focused.confirm = true
                          _vm.focused.old = false
                          _vm.focused.new = false
                        },
                      },
                      model: {
                        value: _vm.form.confirmPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "confirmPassword", $$v)
                        },
                        expression: "form.confirmPassword",
                      },
                    }),
                    _vm._v(" "),
                    _vm.focused.confirm
                      ? _c("fa", {
                          staticClass: "password-toggle",
                          attrs: {
                            icon: [
                              "fas",
                              _vm.passwordVisible ? "eye-slash" : "eye",
                            ],
                          },
                          on: {
                            click: function ($event) {
                              _vm.passwordVisible = !_vm.passwordVisible
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "py-2 w-100 justify-content-center",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "save-btn px-4 py-2",
                  on: {
                    click: function ($event) {
                      return _vm.checkForm()
                    },
                  },
                },
                [_vm._v("Save new password")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }